
<template>
  <div>
    <div class="header">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search />
      </div>
    </div>
    <div>
      <cart-side />
    </div>
    <div>
      <app-nav />
    </div>
    <div class="quotation">
      <div class="choose-box">
        <div>
          <b-toast id="msg" class="msg" no-close-button variant="secondary" static auto-hide-delay="100">
            {{ Msg }}
          </b-toast>
        </div>
        <div class="choose-box-nav">
          <div class="upload"><button @click="changeNav(true)">上传报价商品</button></div>
          <div class="serach"><button @click="changeNav(false)">查询报价结果</button></div>
        </div>
        <div>
          <div v-if="showUpload">
            <span class="upload-proposal">
              <b-form-file v-model="file" plain class="upload-input" />
              <button>
                上传报价单
              </button>
            </span>
            <span class="download-proposal"><button @click="downloadQuotation">下载报价单模板</button></span>
          </div>
          <div v-if="!showUpload" class="choose-time">
            <div class="choose-time-box">
              <span class="select-time">
                <el-date-picker
                  v-model="startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="small"
                  type="datetime"
                  class="starttime-input"
                  clear-icon
                />
              </span>
              <p>至</p>
              <span class="select-time">
                <el-date-picker
                  v-model="endTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="small"
                  type="datetime"
                  class="starttime-input"
                  clear-icon
                />
              </span>
            </div>
            <div>
              <button class="serach-quotation-button" @click="serachQuotation">查询</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isHaveResult" class="result">
        <span v-for="(quotation,index) in quotations" :key="index" @click="getItemList(quotation)">
          {{ quotation }}
        </span>
      </div>
      <!--查询列表-->
      <div v-if="isHaveItem">
        <item-list :quotationid="quotationId" />
      </div>
    </div>
    <div class="footer">
      <app-footer />
    </div>
  </div>
</template>
<script>
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import CartSide from './CartSide'
import nav from '@/components/Nav.vue'
import { ItemService } from '../../service/ItemService'
import ItemList from './ItemList.vue'
export default {
  components: {
    'item-list': ItemList, 'cart-side': CartSide,
    search, topbar, 'app-nav': nav, 'app-footer': footer
  },
  data () {
    return {
      file: {},
      quotationId: '',
      isHaveItem: false,
      quotations: [],
      isHaveResult: false,
      Msg: '',
      showUpload: true,
      startTime: '',
      endTime: ''
    }
  },
  watch: {
    file: function (newV, oldV) {
      if (newV !== null && newV !== undefined) {
        this.uploadQuotation()
      }
    }
  },
  methods: {
    uploadQuotation () {
      // 上传文件
      console.log(this.file)
      const file = this.file
      const fileName = this.file.name
      const itemService = new ItemService(this.$axios)
      if (this.checkFile(fileName)) {
        var data = new FormData()
        data.append('file', file)
        itemService.loadQuotation(data).then(res => {
          if (res.code === '0') {
            this.showMsg('上传成功')
          } else {
            this.showMsg('上传失败')
          }
          this.file = {}
        }).catch(res => {
          this.showMsg('上传失败')
          this.file = {}
        })
      }
    },
    checkFile (string) {
      // 检查文件是否能提交
      if (string === undefined) {
        return false
      }
      const suffix = string.substr(string.lastIndexOf('.'))
      if (suffix !== '.xls' && suffix !== '.xlsx') {
        this.showMsg('请参照模板上传')
        this.file = {}
        return false
      }
      return true
    },
    getItemList (quotation) {
      console.log('quotation++++++++', quotation)
      this.quotationId = quotation
      this.isHaveItem = true
    },
    changeNav (boolean) {
      this.showUpload = boolean
      if (boolean) {
        // 如果点击上传，报价结果隐藏
        this.isHaveResult = false
        this.isHaveItem = false
      }
    },
    serachQuotation () {
      console.log('订单时间______', this.startTime, this.endTime)
      const itemService = new ItemService(this.$axios)
      if (this.checkDate()) {
        var data = {
          params: {
            startTimeStr: this.startTime,
            endTimeStr: this.endTime
          }

        }
        itemService.loadQuotationsId(data).then(res => {
          const { content } = res
          if (content.length === 0) {
            this.showMsg('没有查询结果！')
          } else {
            this.quotations = []
            content.forEach(quotation => {
              console.log('订单时间______', quotation)
              this.quotations.push(quotation.id)
            })
            this.isHaveResult = true
          }
        })
      }
    },
    showMsg (msg) {
      this.Msg = msg
      this.$bvToast.show('msg')
    },
    downloadQuotation () {
      // 下载报价单
      window.open('https://lyly360.oss-cn-shenzhen.aliyuncs.com/%E6%8A%A5%E4%BB%B7%E5%8D%95%E6%A8%A1%E6%9D%BF.xls')
    },
    checkDate () {
      // 检查日期请求是否正确，
      if (this.startTime === '') {
        this.showMsg('请选择起始时间')
        return false
      }
      if (this.endTime === '') {
        this.showMsg('请选择结束时间')
        return false
      }
      const tmpStartTime = new Date(this.startTime.replace(/-/g, '\/'))
      const tmpEndTime = new Date(this.endTime.replace(/-/g, '\/'))
      console.log('订单时间111______', tmpStartTime, tmpEndTime)
      if (tmpStartTime > tmpEndTime) {
        this.showMsg('起始时间大于结束时间')
        return false
      }
      return true
    }
  }
}
</script>
<style scoped>
.topbar{
  width: 100%;
  background-color: #e3e4e5
}
.quotation{

  min-height: 1000px
}
.choose-time{
display: flex;
margin-top: 55px;
margin-left:55px;
}
.choose-time-box{
  display: flex;
}
.choose-time-box p{
  margin-top: 5px;
  margin-left: 20px;
  margin-right: 20px;
}
.choose-box{
  display: flex;
  width: 1200px;
  height: 150px;
  border: 1px #000000 solid;
  margin: 8px auto 0;
  background-color: #ffffff;
}
.upload{
  margin-top: 15px;
   margin-left: 50px;
}
.serach{
  margin:13px 0px 11px 50px;
}
.upload-proposal{
  display: inline-block;
  margin-left: 227px;
  margin-top: 54px;
}
.download-proposal{
    margin-top: 55px;
  margin-left: 36px;
}
.date-input-style{
  width: 180px;
  height: 34px;
}
.choose-box-nav button{
  border: 0px solid transparent;
  outline:0 none !important;
  font-size: 18px;
  width: 150px;
  height: 50px;
  border-radius: 5px;
  color: #ffffff;
  background-color: #feb140;
  box-shadow: 2px 2px 1px #888888;
}
.upload-proposal button{
   border: 0px solid transparent;
  outline:0 none !important;
  font-size: 16px;
  width: 150px;
  height: 40px;
  border-radius: 5px;
  color: #ffffff;
  background-color: #e31220;
  box-shadow: 2px 2px 1px #888888;
}
.download-proposal button{
   border: 0px solid transparent;
  outline:0 none !important;
  font-size: 16px;
  width: 150px;
  height: 40px;
  border-radius: 5px;
  color: #ffffff;
  background-color: #50a9e8;
  box-shadow: 2px 2px 1px #888888;
}
.serach-quotation-button{
  margin-left: 28px;
  margin-top: -5px;
  display: inline-block;
  border: 0px solid transparent;
  outline:0 none !important;
  font-size: 16px;
  width: 60px;
  height: 40px;
  border-radius: 5px;
  color: #ffffff;
  background-color: #e62c39;
  box-shadow: 2px 2px 1px #888888;
}
 button:active{
    box-shadow: 2px 2px 1px #ffffff;
}
.choose-time-box span.select-time {
    display:inline-block;
    width: 220px;
    background-color: #fff;
    text-align: left;
  }
.result{
  cursor: pointer;
  text-align: left;
  flex-wrap:wrap;
  border: 1px #000000 solid;
  margin: 0 auto ;
  width: 1200px;
  background-color: #ffffff;
}
.upload-input{
  cursor:pointer;
  position: absolute;
  width: 150px;
  height: 40px;
  opacity:0;
}
.result span{
  display: inline-block;
  width: 110px;
  height: 45px;
  line-height: 45px;
  margin-left: 35px;
  text-align: center;
}
.msg{
position:fixed;
top:18%;
left: 48%;
}
.footer{
  margin-top: 50px;
  height: 140px
}
</style>
